<template>
  <div>
    <v-card elevation="1">
      <v-card-text>
        <h3>Produccion de subrecetas</h3>
        <v-divider />
        <v-form ref="formPresentacion">
          <v-row class="mt-2">
            <v-col md="2">
              <v-autocomplete
                :disabled="Produccion.sts == 'A'"
                label="Almacén salida"
                v-model="Produccion.ams"
                :rules="rules.Requerido"
                :items="origenes"
                item-text="Nombre"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="2">
              <v-autocomplete
                :disabled="Produccion.sts == 'A'"
                label="Almacén entrada"
                v-model="Produccion.ame"
                :rules="rules.Requerido"
                :items="origenes"
                item-text="Nombre"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="2">
              <v-autocomplete
                :disabled="Produccion.sts == 'A'"
                label="Departamento"
                v-model="Produccion.dpt"
                :rules="rules.Requerido"
                :items="modulos"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="2">
              <v-autocomplete
                :disabled="Produccion.sts == 'A'"
                label="Estatus"
                v-model="Produccion.sts"
                :rules="rules.Requerido"
                :items="estatusList"
                item-text="name"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="4">
              <div class="text-right">
                <v-btn @click="$emit('toggle', false)">Cerrar</v-btn>
                <v-btn
                  v-if="edit && Produccion.sts != 'A' && Produccion.sts != 'C'"
                  color="orange"
                  dark
                  @click="aplicarProd()"
                >
                  Aplicar</v-btn
                >
                <v-btn
                  v-if="Produccion.sts != 'A'"
                  color="green"
                  dark
                  @click="saveOrdenCompra()"
                  >Guardar</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-divider />
        <v-row class="mt-2">
          <v-col md="4">
            <h4>Agregar subrecetas</h4>
            <v-form ref="formProdAdd">
              <v-autocomplete
                label="Subreceta"
                :rules="rules.Requerido"
                v-model="reqToAdd.sub"
                :items="global_prod"
                item-text="Nombre"
                item-value="id"
              >
              </v-autocomplete>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    v-model="reqToAdd.pcn"
                    :rules="rules.Requerido"
                    @keypress="$pgsHelper.onlyNumber($event, reqToAdd.pcn)"
                    :label="'Porciones a producir :'"
                  >
                  </v-text-field>
                </v-col>
                <v-col md="8">
                  <div v-if="subrecetaSelected">
                    <h4>
                      porciones generarán
                      {{
                        $pgsHelper.formatNumber(
                          Number(subrecetaSelected.Extra.AYB.Rm) *
                            Number(reqToAdd.pcn)
                        )
                      }}
                      {{ unidadMedida }} de {{ subrecetaSelected.Nombre }}
                    </h4>
                  </div>
                </v-col>
              </v-row>

              <v-list v-if="subrecetaSelected">
                <h5>Ingredientes de la subreceta seleccionada</h5>
                <v-list-item
                  v-for="(ingrediente, index) in subrecetaSelected.Catalogo"
                  :key="index"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ ingrediente.Nombre }} - {{ ingrediente.Cantidad }}
                      {{ ingrediente.Extra.AYB.UM }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-form>
            <v-btn
              v-if="Produccion.sts != 'A'"
              block
              color="green"
              @click="addProd()"
              outlined
              dark
              >Agregar Subrecetas</v-btn
            >
          </v-col>
          <v-col md="8" v-if="Produccion.prd">
            <h4>Productos a producir</h4>
            <v-btn @click="deleteInsumo()" outlined color="red"
              ><v-icon>mdi-delete</v-icon> Eliminar productos</v-btn
            >
            <ag-grid-vue
              v-if="Produccion.prd.length > 0"
              style="height: 300px"
              class="ag-theme-alpine"
              :columnDefs="columnDefs"
              rowSelection="single"
              :rowData="Produccion.prd"
              @gridReady="ongridReady($event)"
              @selection-changed="onSelectionChanged($event)"
            >
            </ag-grid-vue>
            <v-alert
              v-if="Produccion.prd.length == 0"
              border="bottom"
              colored-border
              type="info"
              elevation="2"
            >
              La orden de compra esta vacia.
            </v-alert>
          </v-col>
        </v-row>

        <v-divider />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Produccion from "../../../clases/Restaurante/Produccion.js";
import { mapGetters } from "vuex";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
export default {
  name: "ProduccionAYBForm",
  components: { AgGridVue },
  props: ["edit", "dataEdit"],
  data() {
    return {
      monedas: Currency.getCurrencies(),
      origenes: [],
      estatusList: Produccion.getStatusList(),
      Produccion: Produccion.getPropertyModel(),
      rules: Produccion.getRules(),
      columnDefs: null,
      reqToAdd: {
        nom: "",
        sub: null,
        pcn: 1,
        //cto: { C: 0, M: "MXN" },
        ord: 1,
      },
      selection: [],
      /*presentacion: PresentacionesAYB.getPropertyModel(),
      presentaciones:[],
      rules:PresentacionesAYB.getRules(),
      Proveedores:[],*/
    };
  },
  methods: {
    deleteInsumo() {
      this.selection.forEach((selectProd) => {
        let prod = this.$pgsHelper.getById(
          this.Produccion.prd,
          "sub",
          selectProd.sub
        );
        
        if (prod) {
          this.Produccion.prd.splice(prod.idx, 1);
        }
      });
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();
      
      this.selection = selectedRows;
    },
    ongridReady: function(params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    addProd() {
      if (this.$refs.formProdAdd.validate()) {
        let prod = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          this.reqToAdd.sub
        );
        this.reqToAdd.nom = prod.Nombre;
        this.reqToAdd.ord = this.Produccion.prd.length + 1;
        this.Produccion.prd.push(this.$pgsHelper.cloneObj(this.reqToAdd));
        this.reqToAdd = {
          nom: "",
          sub: null,
          pcn: 1,
          //cto: { C: 0, M: "MXN" },
          ord: 1,
        };
      }
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    aplicarProd() {
      let datos = { Id: this.Produccion.Id };
      this.$alert.alertConfirm({
        action: "enviar a inventario",
        obj: "la produccion",
        route: "AYB-Producciones-applyProduccion",
        data: datos,
        onSuccess: () => {
          //this.getPresentacionesByProduct()
          this.$emit("successData");
        },
      });
    },
    saveOrdenCompra() {
      if (this.$refs.formPresentacion.validate()) {
        this.Produccion.prd.forEach((prod) => {
          prod.pcn = Number(prod.pcn);
          //prod.cto.C = Number(prod.cto.C);
        });
        this.Produccion.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
        let datos = this.Produccion;
        this.$alert.alertConfirm({
          action: this.edit ? "editar" : "agregar",
          obj: "el documento de produccion",
          route: this.edit
            ? "AYB-Producciones-updateProduccion"
            : "AYB-Producciones-createProduccion",
          data: datos,
          onSuccess: () => {
            //this.getPresentacionesByProduct()
            this.$emit("successData");
          },
        });
      }
    },
  },
  computed: {
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    unidadMedida() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.reqToAdd.sub
      );
      
      if (prod) {
        return prod?.Extra?.AYB?.UM || "PZ";
      }
      return "";
    },
    subrecetaSelected() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.reqToAdd.sub
      );

      if (prod) {
        prod.Catalogo.forEach((data) => {
          data.Nombre = this.$pgsHelper.getById(
            this.$store.getters.getProductos,
            "id",
            data.Id
          ).Nombre;
        });
        
        return prod;
      }
      return null;
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        if (
          element.Tipo == "AYB-ICompuesto" &&
          !element.Dlat &&
          element.Departamentos.includes(this.Produccion.dpt)
        ) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {},
  beforeMount: function() {},
  mounted() {
    this.columnDefs = [
      { field: "nom", headerName: "Subreceta" },
      { field: "pcn", editable: true, headerName: "Cantidad" },
      { field: "ord", editable: true, headerName: "Orden de produccion" },
    ];
    this.getOrigenes();
    if (this.edit) {
      this.Produccion = new Produccion(this.dataEdit);
      
    } else {
      this.Produccion = new Produccion();
    }
  },
};
</script>
